import {
  checkElementExistence, onClickOutside, ToggleBlock,
} from './helpers';

document.addEventListener('DOMContentLoaded', () => {
  (async () => {
    if (checkElementExistence('[data-main-slider]')) {
      const {
        MainSlider,
      } = await import('./components/MainSlider');

      MainSlider();
    }

    if (checkElementExistence('[data-form]')) {
      const {
        Form,
      } = await import('./components/Form');

      Form();
    }

    if (checkElementExistence('[data-phone]')) {
      const {
        Phone,
      } = await import('./components/ui/Phone');

      await Phone();
    }

    if (checkElementExistence('[data-main-menu]')) {
      const {
        MainMenu,
      } = await import('./components/MainMenu');

      MainMenu();
    }
  })();

  (() => {
    const header: HTMLElement | null = document.querySelector('[data-header]');

    if (header) {
      const headerParent: HTMLElement | null = header.parentElement;
      const scrollEvent = new Event('scroll');

      window.addEventListener('scroll', () => {
        if (headerParent) {
          if (window.scrollY >= headerParent.offsetTop) {
            header.classList.add('fixed');
          } else {
            header.classList.remove('fixed');
          }
        }
      });

      window.dispatchEvent(scrollEvent);
    }
  })();

  (async () => {
    if (checkElementExistence('[data-language]')) {
      const {
        ToggleBlock,
      } = await import('./helpers/toggleBlock');

      ToggleBlock({
        blockSelector: '[data-language]',
        buttonSelector: '[data-language-button]',
      });

      onClickOutside('[data-language]');
    }
  })();
});
